import { Box, Stack } from "@mui/material";
import { ProgressCarousel } from "@src/appV2/redesign/components/ProgressCarousel";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { EducationExampleCard, type ExampleItem } from "./EducationExampleCard";
import { EducationStepNavigation } from "./EducationStepNavigation";

interface EarnPointsStepProps {
  onNext: () => void;
  onBack: () => void;
  pointsForWorkingShift: number;
  progressCarousel?: {
    currentIndex: number;
    totalSteps: number;
    onIndexChange: (index: number) => void;
  };
}

export function EarnPointsStep(props: EarnPointsStepProps) {
  const { onNext, onBack, pointsForWorkingShift, progressCarousel } = props;

  const examples: ExampleItem[] = [
    {
      label: "Completing a shift",
      points: `+ ${pointsForWorkingShift}`,
      isPositive: true,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "35%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            paddingX: 2,
          }}
        >
          <EducationExampleCard examples={examples} />
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: "65%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Stack spacing={6} alignItems="center" sx={{ width: "100%", maxWidth: 343 }}>
            <Text
              variant="h4"
              sx={(theme) => ({
                fontSize: "32px",
                color: theme.palette.text.primary,
                lineHeight: "35px",
                textAlign: "center",
              })}
            >
              Earn points by completing shifts
            </Text>
            <Text
              variant="body1"
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                fontSize: "16px",
                lineHeight: "17px",
                textAlign: "center",
              })}
            >
              When you show up and do great work, your score grows, and workplaces see you as
              someone they can count on!
            </Text>
          </Stack>
        </Box>

        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          <Stack spacing={2} sx={{ width: "100%" }}>
            {progressCarousel && (
              <Box sx={{ paddingX: 2 }}>
                <ProgressCarousel
                  currentIndex={progressCarousel.currentIndex}
                  totalCount={progressCarousel.totalSteps}
                  onIndexChange={progressCarousel.onIndexChange}
                />
              </Box>
            )}
            <EducationStepNavigation onNext={onNext} onBack={onBack} />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
